export default __webpack_public_path__ + "static/media/i019vp.1efe9bbf.webp";